import React from 'react';
import './POISidebar.css';
import { POI_CATEGORIES } from '../../utils/constants';
import { getPoiAddress } from '../../utils/poiAddress';

const POISidebar = ({
  show,
  pois,
  selectedCategory,
  onClose,
  onDirections
}) => {
  if (!show) return null;

  const hasPOIs = pois && pois.length > 0;

  // Get category name from selectedCategory ID
  const getCategoryName = () => {
    if (!selectedCategory) return 'POI';

    const categoryKey = selectedCategory.toUpperCase();
    const category = POI_CATEGORIES[categoryKey];
    return category ? category.name : 'POI';
  };

  return (
    <div className="poi-sidebar">
      <div className="poi-sidebar-header">
        <button className="poi-sidebar-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div className="poi-sidebar-content">
        {!hasPOIs ? (
          <div className="poi-empty-state">
            No available {getCategoryName()} found in the selected region
          </div>
        ) : (
          pois.map((poi, index) => {
            const props = poi.properties || {};
            let amenity = props.amenity || props.shop || props.tourism || props.leisure;
            if (!amenity && props.class) {
              amenity = props.class.toLowerCase().replace(/\s+/g, '_');
            }

            const name = props.name || (amenity ? amenity.charAt(0).toUpperCase() + amenity.slice(1) : 'Unknown');
            const address = getPoiAddress(props);

            const coords = poi.geometry?.coordinates || [];
            const [lon, lat] = coords;

            // Skip if invalid coordinates
            if (!lon || !lat || isNaN(lon) || isNaN(lat)) {
              return null;
            }

            return (
              <div key={index} className="poi-sidebar-item">
                <div className="poi-item-details">
                  <h3>{name}</h3>
                  <p>{address || 'No address available'}</p>
                </div>
                <button
                  className="poi-item-directions"
                  onClick={() => onDirections(lat, lon, name)}
                  title="Get Directions"
                >
                  <img src="/icons/_v1rightDirectionIcon.png" alt="Directions" />
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default POISidebar;
